export const isAbsolute = (href) => /^https?:\/\//i.test(href || "");

export const toPageHref = (slug, locale = "fr") =>
  locale === "fr" ? `/page/${slug}` : `/${locale}/page/${slug}`;

export const normalizeHref = (href) => {
  if (!href) return href;
  if (isAbsolute(href)) return href;

  return href.replace(/^\/pages\//, "/page/");
};

export const getMenuItemHref = (item) => {
  const raw =
    item?.url ||
    (item?.page?.slug
      ? toPageHref(item.page.slug, item.page.locale || "fr")
      : null);

  return normalizeHref(raw);
};

export const getPrimaryBgStyle = (settings) => {
  const hex = settings?.primary_color?.trim();

  if (hex) {
    return { backgroundColor: hex };
  }

  return { backgroundColor: "rgb(var(--color-btn-primary, 18 119 185))" };
};

export const getBrandBg = () => ({
  backgroundColor: "rgb(var(--color-btn-primary, 18 119 185))",
});

export const getBrandText = () => ({
  color: "rgb(var(--color-on-btn-primary, 255 255 255))",
});

export const getSocialLinks = (settings) =>
  [
    {
      key: "facebook",
      label: "Facebook",
      href: settings?.link_facebook?.trim(),
    },
    {
      key: "instagram",
      label: "Instagram",
      href: settings?.link_instagram?.trim(),
    },
    {
      key: "youtube",
      label: "YouTube",
      href: settings?.link_youtube?.trim(),
    },
    {
      key: "linkedin",
      label: "LinkedIn",
      href: settings?.link_linkedin?.trim(),
    },
  ].filter((item) => Boolean(item.href));

export const getContactInfo = (settings) => {
  const email = settings?.email_contact?.trim();
  const phone = settings?.telephone_contact
    ? String(settings.telephone_contact).replace(/\s+/g, "")
    : "";

  return {
    email,
    phone,
  };
};

export const getInitials = (user) => {
  const full =
    user?.displayName ||
    [user?.prenom, user?.nom].filter(Boolean).join(" ") ||
    user?.email ||
    "";

  const parts = String(full).trim().split(/\s+/);
  const take = (value) => (value ? value.charAt(0).toUpperCase() : "");

  return (take(parts[0]) + take(parts[1] || "")).slice(0, 2) || "•";
};

const palette = [
  {
    border: "border-sky-500",
    badge: "bg-sky-500",
    soft: "bg-sky-500/10",
    text: "text-sky-200",
  },
  {
    border: "border-emerald-500",
    badge: "bg-emerald-500",
    soft: "bg-emerald-500/10",
    text: "text-emerald-200",
  },
  {
    border: "border-amber-500",
    badge: "bg-amber-500",
    soft: "bg-amber-500/10",
    text: "text-amber-200",
  },
  {
    border: "border-violet-500",
    badge: "bg-violet-500",
    soft: "bg-violet-500/10",
    text: "text-violet-200",
  },
];

export const styleFor = (index) => palette[index % palette.length];